/** @jsx jsx */

import { jsx, render, Query, SelectionSet, Field, Variable, IdScalar, StringScalar, ListScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  id: string;
  typeTrack: string | null;
  countryCode: string[] | null;
}>;

export const GetTrackLicense = async (option: Option) => {
  const $metadataId = <Variable name="metadata_id" scalar={<IdScalar />} value={option.id} />;
  const $typeTrack = <Variable name="type_track" scalar={<StringScalar />} value={option.typeTrack} />;
  const $countryCode = (
    <Variable name="country_code_list" scalar={<ListScalar scalar={<StringScalar isNullable={false} />} />} value={option.countryCode} />
  );
  const { query, variables } = render(
    <Query operationName="GET_TRACK_LICENSE">
      <SelectionSet
        name="metadata"
        argument={{
          where: {
            metadata_id: $metadataId
          }
        }}
      >
        <SelectionSet
          name="track_license"
          alias="licenses"
          argument={{
            first: 99,
            where: {
              type_track: $typeTrack,
              country_code__in: $countryCode
            }
          }}
        >
          <Field name="id" />
          <Field name="copyright" />
          <Field name="neighboring" />
          <Field name="notice" />
          <Field name="country_code" />
          <Field name="publish_date" />
          <Field name="license_date" />
          <Field name="type_track" />
          <Field name="is_service" />
          <Field name="valid_check" alias="validCheck" />
        </SelectionSet>
      </SelectionSet>
    </Query>
  );
  type Data = Readonly<{
    metadata: Readonly<{
      licenses: Readonly<{
        id: string;
        copyright: boolean | undefined;
        neighboring: boolean | undefined;
        notice: string;
        country_code: string;
        publish_date: string | null;
        license_date: string | null;
        type_track: string;
        is_service: number;
        validCheck: ValidType;
      }>[];
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
